import Vue from "vue";
import moment from "moment";

const round = (value) => {
  if (value) {
    return Math.round(Number(value));
  } else {
    return value;
  }
};
const amountFilter = (value) => {
  if (value) {
    return value.toFixed(2);
  } else {
    return "00.00";
  }
};
const amountFilterWithCurrency = (value) => {
  if (value) {
    return "₹" + Number(value).toFixed(2);
  } else {
    return "₹00.00";
  }
};
const amountPaisaFilterWithCurrency = (value) => {
  if (value) {
    return "₹" + Number(value == 0 ? 0 : value / 100).toFixed(2);
  } else {
    return "₹00.00";
  }
};
const dateFilter = (value) => {
  if (value) {
    return moment(new Date(value.trim()), "YYYY-MM-DD").format("ddd, MMM DD");
  } else {
    return "";
  }
};
const dateFilter2 = (value) => {
  if (value) {
    return moment(new Date(value.trim()), "YYYY-MM-DD").format("DD MMM YYYY");
  } else {
    return "";
  }
};
const timeFilterWithoutSeconds = (value) => {
  if (value) {
    return moment(
      typeof value === "string" ? new Date(value.trim()) : value,
      "HH:mm:ss"
    ).format("hh:mm a");
  } else {
    return "_ _";
  }
};
const timeFilter = (value) => {
  if (value) {
    return moment(
      typeof value == "string" ? new Date(value.trim()) : value,
      "HH:mm:ss"
    ).format("hh:mm:ss a");
  } else {
    return "_ _";
  }
};
const timeFilter2 = (value) => {
  if (value && typeof value == "string") {
    const timeSplit = value.split(":");
    if (Number(timeSplit[0]) <= 12) {
      if (timeSplit[0] == 0) {
        return `12:${timeSplit[1]} AM`;
      }
      return `${value} AM`;
    } else {
      return `${(timeSplit[0] - 12).toString().padStart(2, "0")}:${
        timeSplit[1]
      } PM`;
    }
  } else {
    return "_ _";
  }
};
const timeStampFilter = (value) => {
  if (value) {
    return (
      " at " +
      moment(new Date(value.trim()), "YYYY-MM-DD HH:mm").format("hh:mm a") +
      " on " +
      moment(new Date(value.trim()), "YYYY-MM-DD HH:mm").format("ddd, MMM DD")
    );
  } else {
    return "";
  }
};
const timeStampFilter1 = (value) => {
  if (value) {
    return moment(
      typeof value == "string" ? new Date(value.trim()) : value,
      "YYYY-MM-DD HH:mm"
    ).format("MMM DD, YYYY hh:mm A");
  } else {
    return "";
  }
};
const timeStampFilter2 = (value) => {
  if (value) {
    return moment(
      new Date(typeof value == "string" ? new Date(value.trim()) : value),
      "YYYY-MM-DD HH:mm"
    ).format("DD MMM YYYY, hh:mm A");
  } else {
    return "";
  }
};
const itemCount = (items) => {
  if (items && items.length) {
    return `${items.length} ${items.length <= 1 ? "Item" : "Items"}`;
  } else {
    return "0 items";
  }
};
const categoryItemCount = (category) => {
  if (category && category.subcategories && category.subcategories.length) {
    let count = category.items.length;
    category.subcategories.forEach((subcategory) => {
      count +=
        subcategory.items && subcategory.items.length
          ? subcategory.items.length
          : 0;
    });
    return `${count} ${count <= 1 ? "Item" : "Items"}`;
  } else if (category.items && category.items.length) {
    return itemCount(category.items);
  } else {
    return "0 items";
  }
};
const secondFilter1 = (seconds = 0) => {
  if (seconds) {
    let d = Math.floor(seconds / (3600 * 24));
    let h = Math.floor((seconds % (3600 * 24)) / 3600);
    let m = Math.floor((seconds % 3600) / 60);
    let s = Math.floor(seconds % 60);
    return `${d ? d + " Day" : ""}
    ${h ? h + " Hr" : ""}
    ${m ? m + " Min" : ""}
    ${s ? s + " Sec" : ""}`;
  } else {
    return `0 Sec`;
  }
};

const secondFilter = (seconds) => {
  let d = Math.floor(seconds / (3600 * 24));
  let h = Math.floor((seconds % (3600 * 24)) / 3600);
  let m = Math.floor((seconds % 3600) / 60);
  let s = Math.floor(seconds % 60);
  return d
    ? `${d + " days"}`
    : ` ${h.toString().padStart(2, "0")}:${m.toString().padStart(2, "0")}:${s
        .toString()
        .padStart(2, "0")}`;
};

const secondFilter2 = (seconds) => {
  let d = Math.floor(seconds / (3600 * 24));
  return d ? `${d + " days"}` : secondFilter3(seconds);
};

const secondFilter3 = (seconds = 0) => {
  if (seconds) {
    let d = Math.floor(seconds / (3600 * 24));
    let h = Math.floor((seconds % (3600 * 24)) / 3600);
    let m = Math.floor((seconds % 3600) / 60);
    let s = Math.floor(seconds % 60);
    if (d) {
      return `${d} Day`;
    }
    if (h) {
      return `${h} Hr`;
    }
    if (m) {
      return `${m} Min`;
    }
    if (s) {
      return `${s} Sec`;
    }
  } else {
    return `0 Sec`;
  }
};

const phoneNumberFilter = (text) => {
  let reg = /^\+\d{12}$/;
  if (text && reg.test(text.trim())) {
    let arr = text.trim().split("");
    arr.splice(2, 0, " ");
    return arr.join("");
  } else {
    return text;
  }
};
const secondToSecond = (sec) => {
  return `${sec} Sec`;
};
const secondToMinutes = (sec) => {
  return `${Math.floor(sec / 60)} Mins`;
};
const secondToMHours = (sec) => {
  return `${Math.floor(sec / 3600)} Hrs`;
};
const dayFilter = (value) => {
  if (typeof value === "string") {
    value = parseInt(value);
  }
  const today = new Date();
  const messageDate = new Date(value);
  const messageDateString = messageDate.toDateString();

  if (today.toDateString() === messageDateString) {
    return "Today";
  } else {
    let yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);

    return yesterday.toDateString() === messageDateString
      ? "Yesterday"
      : messageDateString;
  }
};
const messageTimeFilter = (value) => {
  if (typeof value === "string") {
    value = parseInt(value);
  }
  const timestamp = new Date(value);
  const now = new Date();

  // Time difference in milliseconds
  const diff = now - timestamp;

  // Convert milliseconds to minutes
  const minutes = Math.floor(diff / 60000);

  if (minutes < 1) {
    return "just now";
  } else if (minutes < 60) {
    return `${minutes} mins ago`;
  } else if (
    timestamp.getDate() === now.getDate() &&
    timestamp.getMonth() === now.getMonth() &&
    timestamp.getFullYear() === now.getFullYear()
  ) {
    // Same day
    const hours = timestamp.getHours();
    const minutes = timestamp.getMinutes();
    return `${hours}:${minutes < 10 ? "0" + minutes : minutes}${
      hours >= 12 ? "pm" : "am"
    }`;
  } else if (
    timestamp.getDate() === now.getDate() - 1 &&
    timestamp.getMonth() === now.getMonth() &&
    timestamp.getFullYear() === now.getFullYear()
  ) {
    // Yesterday
    return "yesterday";
  } else {
    // Other dates
    const month = timestamp.getMonth() + 1;
    const day = timestamp.getDate();
    const year = timestamp.getFullYear();
    return `${month}/${day}/${year}`;
  }
};

Vue.filter("round", round);
Vue.filter("amountFilter", amountFilter);
Vue.filter("amountFilterWithCurrency", amountFilterWithCurrency);
Vue.filter("amountPaisaFilterWithCurrency", amountPaisaFilterWithCurrency);
Vue.filter("date", dateFilter);
Vue.filter("dateFilter2", dateFilter2);
Vue.filter("timeWithoutSeconds", timeFilterWithoutSeconds);
Vue.filter("time", timeFilter);
Vue.filter("time2", timeFilter2);
Vue.filter("timestamp", timeStampFilter);
Vue.filter("timestamp1", timeStampFilter1);
Vue.filter("timestamp2", timeStampFilter2);
Vue.filter("secondFilter", secondFilter);
Vue.filter("secondFilter1", secondFilter1);
Vue.filter("secondFilter2", secondFilter2);
Vue.filter("itemCount", itemCount);
Vue.filter("categoryItemCount", categoryItemCount);
Vue.filter("phoneNumberFilter", phoneNumberFilter);
Vue.filter("secondToSecond", secondToSecond);
Vue.filter("secondToMinutes", secondToMinutes);
Vue.filter("secondToMHours", secondToMHours);
Vue.filter("dayFilter", dayFilter);
Vue.filter("messageTimeFilter", messageTimeFilter);
